module.exports = __webpack_public_path__ + "img/x-symbol.bc2dcc2a.svg";